import Control from "ol/control/Control";
import { unByKey } from "ol/Observable";
import LegendRenderer from "../../utils/LegendRenderer";
/**
 * @protected
 */
const CSS_PREFIX = "legend-control-";
/**
 * @constructor
 * @extends {ol/control/Control~Control}
 * @param opt_options LegendControl options.
 */
export default class LegendControl extends Control {
    constructor(opt_options) {
        const options = Object.assign({}, opt_options);
        const element = document.createElement("div");
        super({ element: element, target: options.target });
        this.style = options.style || null;
        this.mapListeners = [];
        this.hiddenClassName = "ol-unselectable ol-control legend-control";
        this.shownClassName = "shown";
        element.className = this.hiddenClassName;
        const button = document.createElement("button");
        button.className = "legend-control-button";
        element.appendChild(button);
        this.panel = document.createElement("div");
        this.panel.className = "panel";
        element.appendChild(this.panel);
        element.classList.add(CSS_PREFIX + "activation-mode-click");
        element.classList.add("activationModeClick");
        button.onclick = (e) => {
            const evt = e || window.event;
            if (this.element.classList.contains(this.shownClassName)) {
                this.hidePanel();
            }
            else {
                this.showPanel();
            }
            evt.preventDefault();
        };
    }
    /**
     * Set the map instance the control is associated with.
     * @param map The map instance.
     */
    setMap(map) {
        // Clean up listeners associated with the previous map
        for (let i = 0; i < this.mapListeners.length; i++) {
            unByKey(this.mapListeners[i]);
        }
        this.mapListeners.length = 0;
        // Wire up listeners etc. and store reference to new map
        super.setMap(map);
        if (map) {
            this.renderPanel();
            this.mapListeners.push(map.on("click", () => {
                this.hidePanel();
            }), map.on("change:size", (evt) => {
                this.renderPanel();
            }));
        }
    }
    /**
     * Show the Legend panel.
     */
    showPanel() {
        if (!this.element.classList.contains(this.shownClassName)) {
            this.element.classList.add(this.shownClassName);
            this.renderPanel();
        }
    }
    /**
     * Hide the Legend panel.
     */
    hidePanel() {
        if (this.element.classList.contains(this.shownClassName)) {
            this.element.classList.remove(this.shownClassName);
        }
    }
    /**
     * Re-draw the legend panel.
     */
    renderPanel() {
        this.dispatchEvent("render");
        LegendControl.renderPanel(this.getMap(), this.panel, this.style);
        this.dispatchEvent("rendercomplete");
    }
    /**
     * **_[static]_** - Re-draw the legend to represent the current state.
     * @param map The OpenLayers Map instance to render legend for
     * @param panel The DOM Element into which the legend will be rendered
     * @param style Geostyler style for the legened
     */
    static renderPanel(map, panel, style) {
        // Create the event.
        const render_event = new Event("render");
        // Dispatch the event.
        panel.dispatchEvent(render_event);
        while (panel.firstChild) {
            panel.removeChild(panel.firstChild);
        }
        const panel_width = map.getSize()[0] - 60;
        panel.style.width = panel_width + "px";
        panel.style.height = style.rules.length * 33 + 10 + "px";
        const legend_element = document.createElement("div");
        legend_element.className = "infra3dsdk-maplegend";
        panel.appendChild(legend_element);
        //test geostyler legend
        const renderer = new LegendRenderer({
            maxColumnWidth: panel_width,
            maxColumnHeight: style.rules.length * 33,
            overflow: "auto",
            styles: [style],
            size: [panel_width, style.rules.length * 33],
            iconSize: [45, 30],
            hideRect: true,
        });
        renderer.render(legend_element);
        // Create the event.
        const rendercomplete_event = new Event("rendercomplete");
        // Dispatch the event.
        panel.dispatchEvent(rendercomplete_event);
    }
}
//# sourceMappingURL=LegendControl.js.map